var _defs, _rect, _line, _line2, _line3, _line4, _text, _text2, _text3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _polyline, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _circle, _text15, _circle2, _text16, _line5, _text17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg3DailyStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 680 240",
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes grow-bar{from{height:0;y:160}to{}}\n    @keyframes scan-line{0%{transform:translateY(0)}100%{transform:translateY(120px)}}\n    @keyframes today-pulse{0%,100%{opacity:.3}50%{opacity:.8}}\n    @keyframes sparkline{from{stroke-dashoffset:300}to{stroke-dashoffset:0}}\n    .bar1{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .1s both}\n    .bar2{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .25s both}\n    .bar3{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .4s both}\n    .bar4{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .55s both}\n    .bar5{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .7s both}\n    .bar6{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) .85s both}\n    .bar7{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) 1s both}\n    .bar8{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) 1.15s both}\n    .bar9{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) 1.3s both}\n    .bar10{animation:grow-bar .6s cubic-bezier(.4,0,.2,1) 1.45s both}\n    .today-glow{animation:today-pulse 1.5s ease-in-out infinite}\n    .sparkline{stroke-dasharray:300;stroke-dashoffset:300;animation:sparkline 2s ease-out 1.8s forwards}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#060f1e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s-bar",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1d4ed8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06b6d4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s-bar-today",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f472b6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "s-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 680,
    height: 240,
    fill: "url(#s-bg)",
    rx: 20
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 50,
    x2: 650,
    y2: 50,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 90,
    x2: 650,
    y2: 90,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 130,
    x2: 650,
    y2: 130,
    stroke: "#0f1e35",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 160,
    x2: 650,
    y2: 160,
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 54,
    textAnchor: "end",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "HIGH")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 94,
    textAnchor: "end",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "MED")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 134,
    textAnchor: "end",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "LOW")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "bar1",
    x: 60,
    y: 90,
    width: 42,
    height: 70,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "bar2",
    x: 117,
    y: 110,
    width: 42,
    height: 50,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "bar3",
    x: 174,
    y: 60,
    width: 42,
    height: 100,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "bar4",
    x: 231,
    y: 100,
    width: 42,
    height: 60,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "bar5",
    x: 288,
    y: 75,
    width: 42,
    height: 85,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "bar6",
    x: 345,
    y: 120,
    width: 42,
    height: 40,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "bar7",
    x: 402,
    y: 135,
    width: 42,
    height: 25,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.4
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "bar8",
    x: 459,
    y: 80,
    width: 42,
    height: 80,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "bar9",
    x: 516,
    y: 65,
    width: 42,
    height: 95,
    rx: 4,
    fill: "url(#s-bar)",
    opacity: 0.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "bar10 today-glow",
    x: 573,
    y: 85,
    width: 42,
    height: 75,
    rx: 4,
    fill: "url(#s-bar-today)",
    filter: "url(#s-glow)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "sparkline",
    points: "81,90 138,110 195,60 252,100 309,75 366,120 423,135 480,80 537,65 594,85",
    fill: "none",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 81,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "MON")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 138,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "TUE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "WED")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 252,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "THU")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 309,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "FRI")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 366,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "SAT")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 423,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "SUN")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "MON")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 537,
    y: 178,
    textAnchor: "middle",
    fill: "#1e3a5f",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "TUE")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 594,
    y: 178,
    textAnchor: "middle",
    fill: "#f472b6",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "TODAY")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 28,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "USER DAILY ACTIVITY STATS \u2014 30 DAY WINDOW")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 205,
    r: 4,
    fill: "url(#s-bar)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 209,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Activity")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 570,
    cy: 205,
    r: 4,
    fill: "url(#s-bar-today)",
    filter: "url(#s-glow)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 209,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Today")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 205,
    x2: 430,
    y2: 205,
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 440,
    y: 209,
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Trend")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg3DailyStats);
export default __webpack_public_path__ + "static/media/svg3-daily-stats.b8d97435e15fd75f3af99b48bc4ed044.svg";
export { ForwardRef as ReactComponent };